import request from '@/utils/request'

// 新增投标邀请书
export const addInvitationLetter = (data) => {
    return request.post('/api/agent/InvitationLetter/add', data)
}
//投标人列表
export const bidderList = (data) => {
    return request.get('/api/agent/InvitationLetter/bidderList', data)
}
//已确认参加且已支付标书款的邀请标段列表
export const confirmedPaidSections = (data) => {
    return request.get('/api/agent/InvitationLetter/confirmedPaidSections', data)
}
// 投标邀请书详情
export const invitationLetterDetail = (data) => {
    return request.get('/api/agent/InvitationLetter/detail', data)
}
//初始化投标邀请书
export const initInvitationLetter = (projectCode) => {
    return request.get('/api/agent/InvitationLetter/init?projectCode='+projectCode)
}
//投标邀请书列表
export const invitationLetterList = (data) => {
    return request.get('/api/agent/InvitationLetter/list', data)
}

//投标人视角-邀请详情
export const myInvitationDetail = (data) => {
    return request.get('/api/agent/InvitationLetter/myInvitationDetail', data)
}

//我收到的邀请标段列表
export const myInvitationSections = (data) => {
    return request.get('/api/agent/InvitationLetter/myInvitationSections', data)
}

//投标人回复邀请
export const replyInvitation = (data) => {
    return request.get('/api/agent/InvitationLetter/replyInvitation', data)
}
